import React, { useState } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import Header from "../common/Header";
import SideNav from "../common/sideNav";
import { Box } from "@mui/material";
import useGlobalState from "../Context";
import { cleanInitialState } from "../reducer/action";

const RequireAuth = ({ allowedRoles }) => {
  const [{ auth }, dispatch] = useGlobalState();
  const location = useLocation();
  const [showSideNavbar, setShowSideNavbar] = useState(false);
  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };
  const decodedJwt = parseJwt(auth?.token);
  const isTokenExpired =
    auth?.token && decodedJwt ? decodedJwt.exp * 1000 < Date.now() : false;
  if (
    allowedRoles?.includes(auth?.ldapParam?.role) &&
    auth?.token &&
    !isTokenExpired
  ) {
    return (
      <>
        <Box display={"flex"}>
          <Header />
          <SideNav
            anchor={showSideNavbar}
            toggleSideNavbar={setShowSideNavbar}
          />
          <Outlet />
        </Box>
      </>
    );
  } else {
    dispatch(cleanInitialState());
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
};

export default RequireAuth;
